import { PassPlanConfiguration } from '@m/types/api/pass/SelfServiceParkingPassPlan';
import { createEffect, createEvent } from 'effector';

import { SelfServiceParkingPassService } from 'apps/customer/services/SelfServiceParkingPassService';

export const setShowDiscountInput = createEvent<boolean>();

export const fetchPassPreview = createEffect({
  handler: SelfServiceParkingPassService.previewPassPlans,
});

export const setSelectedPlanConfig = createEvent<{ config: PassPlanConfiguration }>();

export const removeDiscount = createEvent();

export const setScannedDiscountUuid = createEvent<{ discountUuid: string }>();

export const setSuccessfulActiveVisitDiscountScan = createEvent<boolean | null>();
